import { IViolationMaterialType } from 'APIPackage/CatalogsModule/interfaces/IViolationMaterialType';
import { IViolationFixMethod } from 'APIPackage/CatalogsModule/interfaces/IViolationFixMethod';
import { IViolationFixGrade } from 'APIPackage/CatalogsModule/interfaces/IViolationFixGrade';
import { ViolationFixGradesEnum } from 'APIPackage/KnmModule/enums/ViolationFixGradesEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

export const fixGradesStaticCatalog: IViolationFixGrade[] = [
  {
    id: 1,
    code: ViolationFixGradesEnum.CORRECT,
    title: 'Исправлено',
  },
  {
    id: 2,
    code: ViolationFixGradesEnum.NOT_CORRECT,
    title: 'Не исправлено',
  },
];

export async function fetchViolationMaterialTypes(): Promise<IViolationMaterialType[]> {
  return apiGet<IViolationMaterialType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/requirement-violation-material-type`,
  );
}

export async function fetchViolationFixMethods(): Promise<IViolationFixMethod[]> {
  return apiGet<IViolationFixMethod[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/requirement-violation-actual-method`,
  );
}

export async function fetchViolationFixGrades(): Promise<IViolationFixGrade[]> {
  return fixGradesStaticCatalog;

  // return apiGet<IViolationFixGrade[]>(
  //   `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/requirement-violation-grade`,
  // );
}
